import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import PasswordOpen from '../../../Images/passwordeyeopen.png'
import PasswordClose from '../../../Images/passwordeyeclose.png'
import config from '../../../config'
import Constants from "../../../Constants/constants";

export const mailExtensionList = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "hotmail.co.uk",
    "hotmail.fr",
    "msn.com",
    "yahoo.fr",
    "wanadoo.fr",
    "orange.fr",
    "comcast.net",
    "yahoo.co.uk",
    "yahoo.com.br",
    "yahoo.co.in",
    "live.com",
    "rediffmail.com",
    "free.fr",
    "gmx.de",
    "web.de",
    "yandex.ru",
    "ymail.com",
    "libero.it",
    "outlook.com",
    "uol.com.br",
    "bol.com.br",
    "mail.ru",
    "cox.net",
    "hotmail.it",
    "sbcglobal.net",
    "sfr.fr",
    "live.fr",
    "verizon.net",
    "live.co.uk",
    "googlemail.com",
    "yahoo.es",
    "ig.com.br",
    "live.nl",
    "bigpond.com",
    "terra.com.br",
    "yahoo.it",
    "neuf.fr",
    "yahoo.de",
    "alice.it",
    "rocketmail.com",
    "att.net",
    "laposte.net",
    "facebook.com",
    "bellsouth.net",
    "yahoo.in",
    "hotmail.es",
    "charter.net",
    "yahoo.ca",
    "yahoo.com.au",
    "rambler.ru",
    "hotmail.de",
    "tiscali.it",
    "shaw.ca",
    "yahoo.co.jp",
    "sky.com",
    "earthlink.net",
    "optonline.net",
    "freenet.de",
    "t-online.de",
    "aliceadsl.fr",
    "virgilio.it",
    "home.nl",
    "qq.com",
    "telenet.be",
    "me.com",
    "yahoo.com.ar",
    "tiscali.co.uk",
    "yahoo.com.mx",
    "voila.fr",
    "gmx.net",
    "mail.com",
    "planet.nl",
    "tin.it",
    "live.it",
    "ntlworld.com",
    "arcor.de",
    "yahoo.co.id",
    "frontiernet.net",
    "hetnet.nl",
    "live.com.au",
    "yahoo.com.sg",
    "zonnet.nl",
    "club-internet.fr",
    "juno.com",
    "optusnet.com.au",
    "blueyonder.co.uk",
    "bluewin.ch",
    "skynet.be",
    "sympatico.ca",
    "windstream.net",
    "mac.com",
    "centurytel.net",
    "chello.nl",
    "live.ca",
    "aim.com",
    "bigpond.net.au"
]


function RegisterForm({ apiBaseUrl, dropdownData ,page ,preSelectedValues ,pathname}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [showPassword, setShowPassword] = useState(false)
  const [casteList, setCasteList] = useState([])
  const navigate = useNavigate()
  const [formErrors, setFormErrors] = useState(null)
  const [isRegistrationLoading, setIsLoginLoading] = useState(false);
  const [isAnyFieldFocused, setIsAnyFieldFocused] = useState(false);

  // console.log("dropdownData", dropdownData);
  // console.log("preSelectedValues", preSelectedValues?.countryId);
  const nameTimeoutRef = useRef(null);

  const [formData, setFormData] = useState({
    name: preSelectedValues?.name || "",
    profileId: preSelectedValues?.profileId || "",
    gender: preSelectedValues?.gender || "",
    motherTongueId: preSelectedValues?.motherTongueId || "",
    religionId: preSelectedValues?.religionId || "",
    denomination: preSelectedValues?.denomination || "",
    countryId: preSelectedValues?.countryId === undefined || preSelectedValues?.countryId === null || preSelectedValues?.countryId === "" ? 499 : preSelectedValues?.countryId || 499,
    phone: preSelectedValues?.phone || "",
    email: preSelectedValues?.email || "",
    password: "",
    terms: "",
    otherCaste: "",
    casteId: preSelectedValues?.casteId || "",
  })
  const isChristian = formData.religionId == "18"

  
  useEffect(() => {
    if (preSelectedValues) {
      setFormData({
        ...formData,
        ...preSelectedValues,
      });
    }
  }, [preSelectedValues]);
  const validateForm = () => {
    const errors = {};

    if (!formData.name) {
      errors.name = "Please Enter Name";
    }

    if (!formData.profileId) {
      errors.profileId = "Please Select Profile Created for";
    }

    if (!formData.gender) {
      errors.gender = "Please Select Gender";
    }

    if (!formData.motherTongueId) {
      errors.motherTongueId = "Please Select Mother Tongue";
    }

    if (!formData.religionId) {
      errors.religionId = "Please Select Religion";
    }

    if (formData.religionId === "18" && !formData.denomination) { // Assuming "1" is the Christian religion ID
      errors.denomination = "Please Select Denomination";
    }

    if (!formData.casteId) {
      errors.casteId = "Please Select Caste";
    }

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Enter a Valid e-mail ID";
    }

    if (!formData.password || formData.password.length < 6 || formData.password.length > 15) {
      errors.password = "Password should contain 6 to 15 characters";
    }

    if (!formData.countryId) {
      errors.countryId = "Country code is required";
    }

    if (!formData.phone) {
      errors.phone = "Please enter mobile number";
    } else {
      const regex = formData.countryId === "499" ? /^\d{10}$/ : /^\d{7,15}$/;
      if (!regex.test(formData.phone)) {
        errors.phone = "Please enter a valid mobile number";
      }
    }

    if (!formData.terms) {
      errors.terms = "Please Agree to the Terms and Conditions";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors)
      return false;
    }

    return true;
  };

  const utmSourceData = localStorage.getItem(Constants.loginLocalStorageKeys.utmSource);
  const utmMediumdata = localStorage.getItem(Constants.loginLocalStorageKeys.utmMedium);
  const utmCampaignData = localStorage.getItem(Constants.loginLocalStorageKeys.utmCampaign);

  const register = (formData) => {
    const isMobileSite = localStorage.getItem("LOGIN_DEVICE") === "Mobile Site";
    setIsLoginLoading(true)

    const request = {
      utmSource: searchParams.get("utm_source") || formData.utmsource || utmSourceData,
      utmMedium: searchParams.get("utm_medium") || formData.utmmedium || utmMediumdata,
      utmCampaign: searchParams.get("utm_campaign") || formData.utmcampaign || utmCampaignData,
      username: formData.name,
      password: formData.password,
      email: formData.email?.trim() === "" ? null : formData.email, // Pass null if email is empty
      mobileNumber: formData.phone,
      apikey: "",
      countryId: formData.countryId,
      profileForId: formData.profileId,
      casteId: formData.casteId,
      motherTongueId: formData.motherTongueId,
      religionId: formData.religionId,
      gender: formData.gender,
      // utmSource: formData.utmsource,
      // utmMedium: formData.utmmedium,
      // utmCampaign: formData.utmcampaign,
      domainId: isChristian ? formData.denomination : null,
      loginFrom: localStorage.getItem("LOGIN_DEVICE"),
      registerfrom: localStorage.getItem("LOGIN_DEVICE"),
      webKey: localStorage.getItem("fcmToken"),
      otherCaste: formData.otherCaste,
    }

  


    fetch(`${apiBaseUrl}/register`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request)
      })
      .then(async response => {
        const data = await response.json();
        return {
          data,
          authorization: response.headers.get('authorization'),
        };
      })
      .then(async ({ data, authorization }) => {
        setIsLoginLoading(false)
        if (data.status === "SUCCESS") {
          localStorage.setItem("LOGIN_NAME", data.data.email ?? "") //username
          localStorage.setItem("LOGIN_PASSWORD", request?.password ?? "")
          localStorage.setItem("LOGIN_ID", data.data.userid) //userid
          localStorage.setItem("IS_LOGGED_IN", true) //userid

          localStorage.setItem("accessToken", authorization);

          if (data.data?.paymentToken) {
            localStorage.setItem("LOGIN_CURRENT_PAGE", "/basicdata")
            window.location.href = data.data?.paymentToken
          } else {
            localStorage.setItem("LOGIN_CURRENT_PAGE", "/basicdata")
            navigate("/basicdata");
          }
        } else {
          // alert(data?.data?.message)
          // localStorage.setItem("ERROR MSG", data?.data?.message ?? "") //username
        }
      })

  }
  const onSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      if(formErrors && formErrors.email == null &&  formErrors.phone == null){
        register(formData)
      }
    }

  }



  useEffect(() => {
    const getCasteList = ({ motherTongueId, religionId }) => {
      fetch(`${apiBaseUrl}/getcaste?motherTongueId=${motherTongueId}&religionId=${religionId}`)
        .then(response => response.json())
        .then(data => {
          setCasteList(data?.data?.castes);
        });
    };

    if (formData.motherTongueId && formData.religionId) {
      getCasteList({ motherTongueId: formData.motherTongueId, religionId: formData.religionId });
    }
  }, [formData.motherTongueId, formData.religionId, apiBaseUrl]);

  useEffect(() => {
    if (formData?.profileId == "2" || formData?.profileId == "4") {
      formData.gender = "M"
      setFormData(formData => ({
        ...formData,
        gender: "M",
      }));
    }
    else if (formData?.profileId == "3" || formData?.profileId == "5") {
      setFormData(formData => ({
        ...formData,
        gender: "F",
      }));
    }
  }, [formData?.profileId])






  const sortedCasteList = casteList?.sort((a, b) => {
    if (a.name === "Others") return 1; // Move "Others" to the end
    if (b.name === "Others") return -1; // Keep other items before "Others"
    return 0; // No change for other items
  });

  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  
  const handleInputChange = (e) => {
    let { name, value, type, checked } = e.target;
    let text = value

    if (name === "name") {
      text = text.trimStart().replace(/[^a-zA-Z .]/g, "").replace(/  +/g, " ");
      text = text.charAt(0).toUpperCase() + text.slice(1)
      var splitStr = text.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      text = splitStr.join(' ');
      if (!(value.split(".").length - 1) <= 1) {
        value = formData.name
      }
      value = text;
    } else if (name === "phone") {
      if (!(value === "" || /^[0-9]*$/.test(value))) {
        value = formData.phone
      }
    }else if(name === "email"){
        let inputExtension = value.toLowerCase().split("@")
        if (!mailExtensionList.includes(inputExtension[1])) {
          if(formErrors?.email){
            setFormErrors(prev => ({
              email: null,
            }));
          }else{
            setFormErrors(prev => ({
              email: "Enter a valid domain",
            }));
          }
        } else {
          setFormErrors(prev => ({
            email: null,
          }));
        }
    }

    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : type === 'radio' ? e.target.value : value,
    });
    setIsAnyFieldFocused(true)
  };
  useEffect(() => {
    if (preSelectedValues) {
      setFormData({
        ...formData,
        ...preSelectedValues,
        name: capitalizeWords(preSelectedValues.name || ""), // Capitalize pre-selected name
      });
    }
  }, [preSelectedValues]);

  const validateOnBlur = (e) => {
    // const { name, value } = e.target;

    // if (name === "email" && value.trim() !== "") {
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   if (!emailRegex.test(value)) {
    //     setFormErrors((prev) => ({
    //       ...prev,
    //       email: "Enter a valid e-mail ID",
    //     }));
    //   } else {
    //     setFormErrors((prev) => ({
    //       ...prev,
    //       email: null,
    //     }));
    //   }
    // }

    // if (name === "phone" && value.trim() !== "") {
    //   const regex = formData.countryId === "499" ? /^\d{10}$/ : /^\d{7,15}$/;
    //   if (!regex.test(value)) {
    //     setFormErrors((prev) => ({
    //       ...prev,
    //       phone: "Please enter a valid mobile number",
    //     }));
    //   } else {
    //     setFormErrors((prev) => ({
    //       ...prev,
    //       phone: null,
    //     }));
    //   }
    // }

    // if (name === "password" && value.trim() !== "") {
    //   if (value.length < 6 || value.length > 15) {
    //     setFormErrors((prev) => ({
    //       ...prev,
    //       password: "Password should contain 6 to 15 characters",
    //     }));
    //   } else {
    //     setFormErrors((prev) => ({
    //       ...prev,
    //       password: null,
    //     }));
    //   }
    // }
  };

  const handleInputBlurChange = (e) => {
    setIsAnyFieldFocused(false)
  }

  const storeApiCall = async (request) => {
    // (localStorage.removeItem('ERROR MSG'))
    request.utmSource = searchParams.get("utm_source") ?? undefined;
    request.utmMedium = searchParams.get("utm_medium") ?? undefined;
    request.utmCampaign = searchParams.get("utm_campaign") ?? undefined;
    request.loginFrom = localStorage.getItem("LOGIN_DEVICE");
    request.registerfrom = localStorage.getItem("LOGIN_DEVICE");

    try {
      // let url = "https://cms-uat.kalyanmatrimony.com/api/storeDetails";
      fetch(`${config.api.chat_api}/api/storeDetails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      })
        .then(async (response) => {
          const data = await response.json();
          
          if (data?.error) {
            if(data?.error == 'This email is already taken'){
              setFormErrors({ email : data?.error })
            }else{
              setFormErrors({ phone : data?.error })
            }
          } 
          // else if(localStorage.getItem('ERROR MSG')){
          //   if (localStorage.getItem('ERROR MSG') === "Mobile Number already Exist") {
          //     setFormErrors({ phone : localStorage.getItem('ERROR MSG') })
          //   }else{
          //     setFormErrors({ email: localStorage.getItem('ERROR MSG') })
          //   }

          // }
          else {
            setFormErrors({ email : null })
            setFormErrors({ phone : null })
          }
          return data;
        })
        .catch((error) => {
          console.error("Network error:", error);
        });

    } catch (error) {
      console.error("Network error:", error);

    }
  };

  const getstoreDetails = async (e) => {
    let request = {};

    if (formData.gender) {
      request.gender = formData.gender;
    }

    if (formData.email.trim() !== '') {
      request.email = formData.email;
    }

    if (formData.countryId) {
      request.countryId = formData.countryId;
    }

    if (formData.profileId) {
      request.profileForId = formData.profileId;
    }

    if (formData.motherTongueId) {
      request.motherTongueId = formData.motherTongueId;
    }

    if (formData.religionId) {
      request.religionId = formData.religionId;
    }

    if (formData.casteId) {
      request.casteId = formData.casteId;
    }

    if (formData.denomination) {
      request.domainId = formData.denomination;
    }

    if (formData.phone) {
      request.mobileNumber = formData.phone;
    }

    if (formData.name.trim() !== '') {
      request.username = formData.name.trim();
    }

    try {
      await storeApiCall(request);
    }
    catch (error) {
      console.error("API call failed:", error.message);
    }
  };

  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const { countryId, phone, email, name } = formData;

    const isPhoneValid =
      (countryId === "499" && phone.length === 10) ||
      (countryId !== "499" && phone.length >= 7 && phone.length <= 15);

    const isEmailValid = emailRegex.test(email);

    // Check conditions based on subMenu prop
    // if (props?.subMenu === "onlineLanding") {
    //   if (isPhoneValid || isEmailValid) {
    //     if (!isMailFocused && phone?.length > 0 && name?.length > 0) {
    //     }
    //   }
    // } else {
    if (isPhoneValid || isEmailValid) {
      if (!isAnyFieldFocused && phone?.length > 0 && name?.length > 0) {
        getstoreDetails();
      }
    }
    // }
  }, [formData, isAnyFieldFocused]);


  useEffect(() => {


    const nameCheckList = async (value) => {
      let request = {
        name: value
      };
      try {
        const response = await fetch(`${config.api.API_URL}/api/validatename`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request),
        });
        const data = await response.json();
        if (data.status === "Success") {
          setFormErrors(prev => ({
            ...prev,
            name: data.data.Messagge
          }));
        }
      } catch (error) {
        console.error("Error validating name:", error);
      }
    };



    if (formData.name) {
      nameTimeoutRef.current = setTimeout(() => {
        nameCheckList(formData.name)
      }, 500);
    }

    return () => {
      if (nameTimeoutRef.current) {
        clearTimeout(nameTimeoutRef.current)
        nameTimeoutRef.current = null
      }
    }
  }, [formData.name]);


  return (
    <>
    {page==="mobileform" ?
    <form className="myForm  mobileview" data-gtm-form-interact-id="0" onSubmit={onSubmit}>
    <div className=" formdivheader">
      <div>
        <label className="formlabel ">
          <input
            type="text"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            autoComplete="off"
            placeholder="Enter Your Name"
            className={`form-controllabel emailinput forminputlable    name`}
          />
        </label>
      </div>
      {formErrors?.name && <div className="errormsg">{formErrors?.name}</div>}
    </div>
    <div className="labelgrid">
      <div className="labeldiv labelcolumn">
        <div>
          <label className="formlabel">
            <select
              id="countryId"
              name="countryId"
              value={formData.countryId}
              onChange={handleInputChange}
              onBlur={handleInputBlurChange}
              className="one form-input forminputcountry countryId">
               <option value="" disabled="">Select</option>
              {dropdownData?.isdcode?.map((isdcode, i) => (
                <option key={isdcode.countryId} className="p-2" value={isdcode.countryId}>
                  {isdcode.isdcode + "," + isdcode.country}
                </option>
              ))}

            </select>
          </label>
        </div>
      </div>
      <div className="labeldiv labelspan">
        <div>
          <label style={{ display: "flex" }} className="formlabel RegPhone">
            <input
              id="phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleInputChange}
              onBlur={handleInputBlurChange}
              autoComplete="off"
              style={{ flex: 1 }}
              placeholder="Enter Your Phone Number"
              className="RegPhone form-input phonenuminput phone"
            />
          </label>
        </div>
      </div>

    </div>

    
    {formErrors?.phone && <div className="errormsgsmobile">{formErrors?.phone}</div>}


    <div className="custom-container ">
              <div className='colspanfirst'>
               <p class="gender-label text-danger">Gender</p>
              </div>
              <div class="colspan">
                <div class="spacex">


                 {
                 <div>
                  <div className="inputspace">
                    <input onChange={handleInputChange} checked={formData.gender == "M"} className="accent-[#D10A11]" type="radio" value="M" id="male" name="gender" />
                    <label for="male" value="M" >Male</label>
                    <input onChange={handleInputChange} className="accent-[#D10A11]" checked={formData.gender == "F"} type="radio" value="F" id="female" name="gender" />
                    <label for="female" value="F">Female</label>
                    <div className="errormsggender ">
                      {formErrors?.gender &&  (
                        formErrors?.gender
                      )}{" "}
                    </div>
                  </div>
                  </div>
                 }

                </div>

              </div>
            </div>


    <div >
      <div className="labelgridfor">
        <p className='profilefor'>Profile Created For</p>
        <div>
        <label className="formlabel">
          <select
            id="profileId"
            value={formData.profileId}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            name="profileId"
            className=" form-input forminputprofilefor profileId">

            {/* Male */}
          {formData?.gender == "M" && <>
            <option className="p-2" value="" disabled hidden>
              --Select--
            </option>
            <option value="1">Myself</option>
            <option value="6">Relative</option>
            <option value="7">Friend</option>
            <option value="4">Brother</option>
            <option value="2">Son</option>
          </>}

          {/* Female */}
          {formData?.gender == "F" && <>
            <option className="p-2" value="" disabled hidden>
              --Select--
            </option>
            <option value="1">Myself</option>
            <option value="6">Relative</option>
            <option value="7">Friend</option>
            <option value="5">Sister</option>
            <option value="3">Daughter</option>
          </>}


          {/* all */}
          {formData?.gender ? null : dropdownData?.profileFor?.map((profile, i) => (
            <option key={profile.id} className="p-2" value={profile.id}>
              {profile.name}
            </option>
          ))}


          </select>
        </label>
        {formErrors?.profileId && <div className="errormsessages">{formErrors?.profileId}</div>}
</div>
      </div>
    </div>
    <div>
    <div className="labelgridfor">
        <p className='profilefor'>Mother Tongue</p>
      
      <div>
        <label className="formlabel">
          <select
            value={formData.motherTongueId}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            id="motherTongueId"
            name="motherTongueId"
            className=" form-input forminput forminputprofilefor motherTongueId">
            <option value="" >
              --Select--
            </option>
            {dropdownData?.motherTongue?.map((language, i) => (
              <option key={language.id} className="p-2" value={language.id}>
                {language.name}
              </option>
            ))}
          </select>
        </label>
        {formErrors?.motherTongueId && <div className="errormsessages">{formErrors?.motherTongueId}</div>}

      </div>
      </div>
    </div>
    <div>
    <div className="labelgridfor">
    <p className='profilefor'>Religion</p>
            <div>
        <label className="formlabel">
          <select
            value={formData.religionId}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            id="religionId"
            name="religionId"
            className=" form-input forminput forminputprofilefor religionId">
            <option value="" >
              --Select--
            </option>
            {dropdownData?.religion?.map((religion, i) => (
              <option key={religion.id} className="p-2" value={religion.id}>
                {religion.name}
              </option>
            ))}
          </select>
        </label>
        {formErrors?.religionId && <div className="errormsessages">{formErrors?.religionId}</div>}

      </div>
      </div>
    </div>
    {isChristian && 
    <div> 
      <div className="labelgridfor denominationDiv">
      <p className='profilefor'>Denomination</p>
      <div>
        <label className="formlabel">
          <select
            id="denominationId"
            value={formData.denomination}
            onBlur={handleInputBlurChange}
            onChange={handleInputChange}
            name="denomination"
            className="  form-input forminput forminputprofilefor denominationId">
            <option value="" >
              --Select--
            </option>
            {dropdownData?.domain?.map((denomination, i) => (
              <option key={denomination.id} className="p-2" value={denomination.id}>
                {denomination.name}
              </option>
            ))}
          </select>
        </label>
        {formErrors?.denomination && <div className="errormsessages">{formErrors?.denomination}</div>}

      </div>
      </div>
    </div>}
    <div>
    <div className="labelgridfor">
    <p className='profilefor'>Caste</p>
          
      <div>
        <label className="formlabel">
          <select
            id="casteId"
            name="casteId"
            value={formData.casteId}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            className=" form-input forminput forminputprofilefor casteId">
            <option
              value=""
              disabled=""
              hidden=""
            >
              -- Select --
            </option>
            {sortedCasteList?.map((caste, i) => (
              <option key={caste.id} className="p-2" value={caste.id}>
                {caste.name}
              </option>
            ))}
          </select>
        </label>
        {formErrors?.casteId && <div className="errormsessages">{formErrors?.casteId}</div>}

      </div>
      </div>
    </div>
    <div className="labeldiv">
      <div>
        <label className="formlabel ">
          <input
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            type="email"
            autoComplete="off"
            placeholder="Enter Your Email"
            className="form-input form-controllabel  forminputlable forminput emailinput email"
            data-gtm-form-interact-field-id="0"
          />
        </label>
      </div>
      {formErrors?.email && <div className="errormsgs">{formErrors?.email}</div>}
    </div>
    <div className="labeldiv">
      <div>
        <label className="pswlabel">
          <input
            id="webRegPwd"
            name="password"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            autoComplete="off"
            placeholder="Enter Your Password"
            className="form-input form-controllabel  forminputlable passwordinput password"
            data-gtm-form-interact-field-id="1"
          />
          <div onClick={() => setShowPassword(prev => !prev)} className="hideicon" style={{ paddingTop: '8px'}}>
            {showPassword
              ? <img
                src={PasswordClose}
                className="eyeicon"
                alt="eyeclose"
              />
              : <img
                src={PasswordOpen}
                className="eyeicon"
                alt="eyeopen"
              />}
          </div>
        </label>
      </div>
      {formErrors?.password && <div className="errormsgs">{formErrors?.password}</div>}
    </div>
    <div className="labeldiv">
      <div style={{ display: "flex", flexDirection: "column", "alignItems": "start" }}>
        <label className="formlabel termslabel">
          <input
            id=""
            name="terms"
            type="checkbox"
            value={formData.terms}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            className="termscheck terms"
            autoComplete="off"
          />
          <span className=" termstext">
            <a href="/terms-and-conditions" target="_blank" className="texthover">
              I Accept your Terms and
              Conditions
            </a>
          </span>
        </label>
        {formErrors?.terms && <div className="errormsgs">{formErrors?.terms}</div>}
      </div>
    </div>
    <div className="labeldiv">
      <div className='submitform'>
        <label className="buttonlabel lablebtn ">
          <button disabled={isRegistrationLoading} type="submit" className="submitbtn ">{isRegistrationLoading ? "Submitting..." : "Submit"}</button>
        </label>
      </div>
    </div>
    <br />
  </form>
   
  :
  <form className="myForm " data-gtm-form-interact-id="0" onSubmit={onSubmit}>
  <div className=" formdivheader">
    <div>
      <label className="formlabel ">
        <input
          type="text"
          name="name"
          id="name"
          value={formData.name}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          autoComplete="off"
          placeholder="Enter Your Name"
          className={`form-control  forminput  ${pathname==="/online-matrimony-site"? "emailinput":"emailinputtext"}  name`}
        />
      </label>
    </div>
    {formErrors?.name && <div className="errormsgs">{formErrors?.name}</div>}
  </div>
  <div className="labelgrid">
    <div className="labeldiv labelcolumn">
      <div>
        <label className="formlabel">
          <select
            id="countryId"
            name="countryId"
            value={formData.countryId}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            className="one form-input forminput countryId">
            <option value="" disabled="">Select</option> 
            {dropdownData?.isdcode?.map((isdcode, i) => (
              <option key={isdcode.countryId} className="p-2" value={isdcode.countryId}>
                {isdcode.isdcode + "," + isdcode.country}
              </option>
            ))}

          </select>
        </label>
      </div>
    </div>
    <div className="labeldiv labelspan">
      <div>
        <label style={{ display: "flex" }} className="formlabel RegPhone">
          <input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleInputChange}
            onBlur={handleInputBlurChange}
            autoComplete="off"
            style={{ flex: 1 }}
            placeholder="Enter Your Phone Number"
            className={`RegPhone form-input ${pathname==="/online-matrimony-site"? "phonenoinputlanding":" phonenoinput "}   phone`}
          />
        </label>
      </div>
    </div>

  </div>
  {formErrors?.phone && <div className="errormsgs">{formErrors?.phone}</div>}
  <div className="labeldiv">
    <div>
      <label className="formlabel">
        <select
          id="gender"
          value={formData.gender}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          name="gender"
          className="one form-input  forminput gender">
          <option
            value=""
            disabled=""
            hidden=""
          >
            Select Gender
          </option>
          <option value="M">Male</option>
          <option value="F">Female</option>
        </select>
      </label>
    </div>
    {formErrors?.gender && <div className="errormsgs">{formErrors?.gender}</div>}

  </div>
  <div className="labeldiv">
    <div>
      <label className="formlabel">
        <select
          id="profileId"
          value={formData.profileId}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          name="profileId"
          className="one form-input forminput profileId">

          {/* Male */}
          {formData?.gender == "M" && <>
            <option className="p-2" value="" disabled hidden>
              --Select--
            </option>
            <option value="1">Myself</option>
            <option value="6">Relative</option>
            <option value="7">Friend</option>
            <option value="4">Brother</option>
            <option value="2">Son</option>
          </>}

          {/* Female */}
          {formData?.gender == "F" && <>
            <option className="p-2" value="" disabled hidden>
              --Select--
            </option>
            <option value="1">Myself</option>
            <option value="6">Relative</option>
            <option value="7">Friend</option>
            <option value="5">Sister</option>
            <option value="3">Daughter</option>
          </>}


          {/* all */}
          <option
            value=""
            disabled=""
            hidden=""
          >
            Profile Created For
          </option>
          {formData?.gender ? null : dropdownData?.profileFor?.map((profile, i) => (
            <option key={profile.id} className="p-2" value={profile.id}>
              {profile.name}
            </option>
          ))}


        </select>
      </label>
    </div>
    {formErrors?.profileId && <div className="errormsgs">{formErrors?.profileId}</div>}
  </div>
  <div className="labeldiv">
    <div>
      <label className="formlabel">
        <select
          value={formData.motherTongueId}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          id="motherTongueId"
          name="motherTongueId"
          className="one form-input forminput motherTongueId">
          <option value="" >
            Select MotherTongue
          </option>

          {dropdownData?.motherTongue?.map((language, i) => (
            <option key={language.id} className="p-2" value={language.id}>
              {language.name}
            </option>
          ))}
        </select>
      </label>
    </div>
    {formErrors?.motherTongueId && <div className="errormsgs">{formErrors?.motherTongueId}</div>}
  </div>
  <div className="labeldiv">
    <div>
      <label className="formlabel">
        <select
          value={formData.religionId}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          id="religionId"
          name="religionId"
          className="one form-input forminput religionId">
          <option value="" >
            Select Religion
          </option>
          {dropdownData?.religion?.map((religion, i) => (
            <option key={religion.id} className="p-2" value={religion.id}>
              {religion.name}
            </option>
          ))}
        </select>
      </label>
    </div>
    {formErrors?.religionId && <div className="errormsgs">{formErrors?.religionId}</div>}
  </div>
  {isChristian && <div className="labeldiv denominationDiv">
    <div>
      <label className="formlabel">
        <select
          id="denominationId"
          value={formData.denomination}
          onBlur={handleInputBlurChange}
          onChange={handleInputChange}
          // onBlur={handleInputBlurChange}
          name="denomination"
          className="one form-input forminput denominationId">
          <option value="" >
           Select Denomination
          </option>
          {dropdownData?.domain?.map((denomination, i) => (
            <option key={denomination.id} className="p-2" value={denomination.id}>
              {denomination.name}
            </option>
          ))}
        </select>
      </label>
    </div>
    {formErrors?.denomination && <div className="errormsgs">{formErrors?.denomination}</div>}
  </div>}
  <div className="labeldiv">
    <div>
      <label className="formlabel">
        <select
          id="casteId"
          name="casteId"
          value={formData.casteId}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          className="one form-input forminput casteId">
          <option
            value=""
            disabled=""
            hidden=""
          >
            Select Caste
          </option>
          {sortedCasteList?.map((caste, i) => (
            <option key={caste.id} className="p-2" value={caste.id}>
              {caste.name}
            </option>
          ))}
        </select>
      </label>
    </div>
    {formErrors?.casteId && <div className="errormsgs">{formErrors?.casteId}</div>}
  </div>
  <div className="labeldiv">
    <div>
      <label className="formlabel ">
        <input
          id="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          type="email"
          autoComplete="off"
          placeholder="Enter Your Email"
          className={`form-input forminput ${pathname==="/online-matrimony-site"? "emailinput":"emailinputtext"}  email`}
          
          data-gtm-form-interact-field-id="0"
        />
      </label>
    </div>
    {formErrors?.email && <div className="errormsgs">{formErrors?.email}</div>}
  </div>
  <div className="labeldiv">
    <div>
      <label className="pswlabel">
        <input
          id="webRegPwd"
          name="password"
          type={showPassword ? "text" : "password"}
          value={formData.password}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          autoComplete="off"
          placeholder="Enter Your Password"
          className="form-input passwordinput password"
          data-gtm-form-interact-field-id="1"
        />
        <div onClick={() => setShowPassword(prev => !prev)} className="hideicon" style={{ paddingTop: '8px'}}>
          {showPassword
            ? <img
              src={PasswordClose}
              className="eyeicon"
              alt="eyeclose"
            />
            : <img
              src={PasswordOpen}
              className="eyeicon"
              alt="eyeopen"
            />}
        </div>
      </label>
    </div>
    {formErrors?.password && <div className="errormsgs">{formErrors?.password}</div>}
  </div>
  <div className="labeldiv">
    <div style={{ display: "flex", flexDirection: "column", "alignItems": "start" }}>
      <label className="formlabel termslabel">
        <input
          id=""
          name="terms"
          type="checkbox"
          value={formData.terms}
          onChange={handleInputChange}
          onBlur={handleInputBlurChange}
          className="termscheck"
          autoComplete="off"
        />
        <span className=" termstext">
          <a href="/terms-and-conditions" target="_blank" className="texthover">
            I Accept your Terms and
            Conditions
          </a>
        </span>
      </label>
      {formErrors?.terms && <div className="errormsgs">{formErrors?.terms}</div>}
    </div>
  </div>
  <div className="labeldiv">
    <div>
      <label className="buttonlabel ">
        <button disabled={isRegistrationLoading} type="submit" className="submitbtn ">{isRegistrationLoading ? "Submitting..." : "Submit"}</button>
      </label>
    </div>
  </div>
  <br />
</form>


  
}
    </>
   




  )
}

export default RegisterForm